'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccessibleDatePicker = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _reactIntl = require('react-intl');

var _airbnbPropTypes = require('airbnb-prop-types');

var _reactDates = require('react-dates');

var _defaultPhrases = require('react-dates/lib/defaultPhrases');

var _isInclusivelyAfterDay = require('react-dates/lib/utils/isInclusivelyAfterDay');

var _isInclusivelyAfterDay2 = _interopRequireDefault(_isInclusivelyAfterDay);

var _getPhrasePropTypes = require('react-dates/lib/utils/getPhrasePropTypes');

var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseIcons = require('@bibliocommons/base-icons');

var _baseFullScreenOverlay = require('@bibliocommons/base-full-screen-overlay');

var _baseFullScreenOverlay2 = _interopRequireDefault(_baseFullScreenOverlay);

var _baseButtons = require('@bibliocommons/base-buttons');

var _baseScreenReaderMessage = require('@bibliocommons/base-screen-reader-message');

var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);

require('react-dates/initialize');

require('react-dates/lib/css/_datepicker.css');

require('../styles/react_dates_overrides.scss');

require('../styles/AccessibleDatePicker.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Initial component setup for airbnb/react-dates library


// Initial css setup for airbnb/react-dates library


var AccessibleDatePicker = exports.AccessibleDatePicker = function (_BcReactComponent) {
  _inherits(AccessibleDatePicker, _BcReactComponent);

  function AccessibleDatePicker(props) {
    _classCallCheck(this, AccessibleDatePicker);

    var _this = _possibleConstructorReturn(this, (AccessibleDatePicker.__proto__ || Object.getPrototypeOf(AccessibleDatePicker)).call(this, props));

    _this.state = {
      date: props.initialDate ? (0, _moment2.default)(props.initialDate) : (0, _moment2.default)()
    };

    _this.bindAll('onDateChange', 'renderExtraButtons', 'renderPhraseOverrides');
    return _this;
  }

  _createClass(AccessibleDatePicker, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.addEventListener('click', this.handleDocumentClick.bind(this));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.handleDocumentClick.bind(this));
    }
  }, {
    key: 'handleDocumentClick',
    value: function handleDocumentClick(e) {
      var wrapper = this._datePicker;
      if (wrapper && wrapper !== e.target && !wrapper.contains(e.target)) {
        this.props.handleClose();
      }
    }
  }, {
    key: 'onDateChange',
    value: function onDateChange(date) {
      var _this2 = this;

      this.props.onDateChange(_moment2.default.isMoment(date) ? date.format('YYYY-MM-DD') : date);
      this.setState({ date: (0, _moment2.default)(date) }, function () {
        return setTimeout(function () {
          _this2.props.handleClose();
        }, 100);
      });
    }
  }, {
    key: 'renderPhraseOverrides',
    value: function renderPhraseOverrides() {
      var intl = this.props.intl;

      // Overrides default screen reader phrases for interactive elements like previous, next buttons

      return _extends({}, _defaultPhrases.SingleDatePickerPhrases, {
        jumpToPrevMonth: intl.formatMessage({ id: 'calendar_prev_month' }),
        jumpToNextMonth: intl.formatMessage({ id: 'calendar_next_month' }),
        dateIsUnavailable: function dateIsUnavailable(_ref) {
          var date = _ref.date;
          return intl.formatMessage({ id: 'calendar_date_is_unavailable' }, { date: date });
        },
        dateIsSelected: function dateIsSelected(_ref2) {
          var date = _ref2.date;
          return intl.formatMessage({ id: 'calendar_date_is_selected' }, { date: date });
        }
      });
    }
  }, {
    key: 'renderExtraButtons',
    value: function renderExtraButtons() {
      var _this3 = this;

      return _react2.default.createElement(
        'div',
        { className: 'date-picker-extra-buttons item-row' },
        _react2.default.createElement(
          _baseButtons.TextButton,
          { className: 'item-column', handleClick: function handleClick() {
              return _this3.onDateChange((0, _moment2.default)().format());
            } },
          _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'calendar_today',
            values: {
              date: _react2.default.createElement(
                _baseScreenReaderMessage2.default,
                null,
                _react2.default.createElement(_reactIntl.FormattedDate, { value: (0, _moment2.default)().format(), year: 'numeric', month: 'short', day: '2-digit' })
              )
            } })
        ),
        _react2.default.createElement(
          _baseButtons.TextButton,
          { className: 'item-column', handleClick: this.props.handleClose },
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_close' })
        )
      );
    }
  }, {
    key: 'renderDatePickerPopUp',
    value: function renderDatePickerPopUp(props) {
      var _this4 = this;

      return _react2.default.createElement(
        'div',
        { className: 'cp-accessible-date-picker-pop-up', ref: function ref(el) {
            _this4._datePicker = el;
          } },
        _react2.default.createElement(
          'div',
          { className: 'cp-accessible-date-picker-content' },
          this.props.children
        ),
        this.props.open && _react2.default.createElement(_reactDates.DayPickerSingleDateController, _extends({}, props, {
          date: this.state.date,
          withPortal: false,
          phrases: this.renderPhraseOverrides(),
          onDateChange: function onDateChange(dateValue) {
            return _this4.onDateChange(dateValue);
          },
          renderCalendarInfo: this.renderExtraButtons }))
      );
    }
  }, {
    key: 'renderFullScreenOverlayDatePicker',
    value: function renderFullScreenOverlayDatePicker(props) {
      var _this5 = this;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _baseFullScreenOverlay2.default,
          {
            className: 'accessible-date-picker-full-screen-overlay',
            open: this.props.open,
            handleClose: this.props.handleClose },
          _react2.default.createElement(_reactDates.DayPickerSingleDateController, _extends({}, props, {
            date: this.state.date,
            phrases: this.renderPhraseOverrides(),
            onDateChange: function onDateChange(dateValue) {
              return _this5.onDateChange(dateValue);
            },
            renderCalendarInfo: this.renderExtraButtons }))
        ),
        _react2.default.createElement(
          'div',
          { className: 'cp-accessible-date-picker-content' },
          this.props.children
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var props = _lodash2.default.omit(this.props, ['initialDate', 'open', 'handleClose', 'intl', 'children', 'displayFormat', 'inputIconPosition', 'fullScreen', 'className']);

      return _react2.default.createElement(
        'div',
        { className: 'cp-accessible-date-picker ' + this.props.className },
        this.props.fullScreen ? this.renderFullScreenOverlayDatePicker(props) : this.renderDatePickerPopUp(props)
      );
    }
  }]);

  return AccessibleDatePicker;
}(_baseBcReactComponent2.default);

var defaultProps = {
  numberOfMonths: 1,
  displayFormat: function displayFormat() {
    return _moment2.default.localeData().longDateFormat('L');
  },
  inputIconPosition: 'after',
  navPrev: _react2.default.createElement(_baseIcons.Angle.Left, null),
  navNext: _react2.default.createElement(_baseIcons.Angle.Right, null),
  hideKeyboardShortcutsPanel: true,
  withPortal: true,
  initialDate: null,
  isOutsideRange: function isOutsideRange(day) {
    return !(0, _isInclusivelyAfterDay2.default)(day, (0, _moment2.default)());
  },
  focused: true,
  fullScreen: false,
  className: ''

};

var propTypes = (0, _airbnbPropTypes.forbidExtraProps)({
  // Props for AccessibleDatePicker component
  intl: _reactIntl.intlShape,
  open: _react.PropTypes.bool,
  handleClose: _react.PropTypes.func.isRequired,
  children: _bcPropTypes.childrenShape,
  fullScreen: _react.PropTypes.bool,
  className: _react.PropTypes.string,
  // Props for DayPickerSingleDateController component
  initialDate: _react.PropTypes.string,
  onDateChange: _react.PropTypes.func,
  focused: _react.PropTypes.bool,
  onFocusChange: _react.PropTypes.func,
  navPrev: _react.PropTypes.node,
  navNext: _react.PropTypes.node,
  phrases: _react.PropTypes.shape((0, _getPhrasePropTypes2.default)(_defaultPhrases.SingleDatePickerPhrases)),
  noBorder: _react.PropTypes.bool,
  hideKeyboardShortcutsPanel: _react.PropTypes.bool,
  displayFormat: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.func]),
  small: _react.PropTypes.bool,
  withPortal: _react.PropTypes.bool,
  inputIconPosition: _react.PropTypes.string,
  numberOfMonths: _react.PropTypes.number,
  renderCalendarInfo: _react.PropTypes.func,
  customInputIcon: _react.PropTypes.node,
  isOutsideRange: _react.PropTypes.func,
  focus: _react.PropTypes.bool
});

AccessibleDatePicker.propTypes = propTypes;
AccessibleDatePicker.defaultProps = defaultProps;

exports.default = (0, _reactIntl.injectIntl)(AccessibleDatePicker);


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-accessibility-date-picker/lib/components/AcessibleDatePicker.component.js
// module id = 1009
// module chunks = 1